import { PortfolioDto, SyncedAssetDto } from '@unistocks/proxy/axios-client';

export const findExternalPortfolio = (syncedAsset: SyncedAssetDto, portfolio: PortfolioDto) =>
  portfolio.syncedPortfolios.find(
    syncedPortfolio => syncedPortfolio.id === syncedAsset.portfolioId
  );
